var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { T } from 'helpers/i18n';
import { toDateTime, toRound } from 'helpers/Format';
import Theme from 'Theme';
import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { TypeMovement } from '../../SettingCashMovements/Model';
import { JsonToExcel } from 'react-json-to-excel';
import { Button } from '../../../elements';
import Text from '../../../elements/Text';
import { api } from '../../../helpers/Api';
var TicketCashDeskDetail = /** @class */ (function (_super) {
    __extends(TicketCashDeskDetail, _super);
    function TicketCashDeskDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.findUser = function (lista, id) {
            var result = lista.find(function (value) { return value.id === id; });
            return result ? result.name : '';
        };
        _this.handleOnSelectItem = function (item) {
            console.error(item.id);
        };
        _this.toggle = function () {
            _this.props.history.goBack();
        };
        _this.getNotUpload = function (tickets) {
            var noUpload = tickets.reduce(function (previousValue, currentValue) {
                if (!currentValue.id) {
                    previousValue.push(currentValue);
                }
                return previousValue;
            }, []);
            console.log('noUpload: ', noUpload);
            return noUpload;
        };
        _this.handleNoUpload = function (tickets) {
            // busco los tickets sin enviar
            var ticketsNotUploaded = _this.getNotUpload(tickets);
            // envío al servidor los tickets no subidos
            api.post('ticketsv2/listtheyellow', ticketsNotUploaded).then(function (result) {
                if (result && result.length > 0) {
                    // actualizo el cierre de caja con los ids de los guardados
                }
            });
        };
        return _this;
    }
    TicketCashDeskDetail.prototype.UNSAFE_componentWillMount = function () {
        // console.log('UNSAFE_componentWillMount')
        if (this.props.history.location.state === undefined) {
            this.props.history.push('/ticketCashDesk');
        }
    };
    TicketCashDeskDetail.prototype.componentDidMount = function () {
        // console.log('TicketCashDeskDetail - componentDidMount')
        // this.props.store!.reports.readTicketGratis()
    };
    TicketCashDeskDetail.prototype.render = function () {
        var _this = this;
        var item = this.props.history.location.state;
        // console.log('item: ', item)
        // console.log('item.articleLines: ', item.articleLines)
        /*return <div>ticket</div>*/
        if (!item) {
            return null;
        }
        var noUploaded = this.getNotUpload(item.printedStretchTickets);
        var articleLines = item.articleLines, movements = item.movements, stretchLines = item.stretchLines, printedStretchTickets = item.printedStretchTickets;
        console.log('printed: ', printedStretchTickets);
        var printedStretchTicketMapeados = printedStretchTickets.map(function (ticket) {
            var _a;
            var lines = {};
            ticket.lines.forEach(function (line, index) {
                lines["passengerCategoryName_line".concat(index)] = line.passengerCategoryName;
                lines["quantity_line".concat(index)] = line.quantity;
                lines["price_line".concat(index)] = line.price;
                lines["taxValue_line".concat(index)] = line.taxValue;
                lines["taxAmount_line".concat(index)] = line.taxAmount;
                lines["taxBase_line".concat(index)] = line.taxBase;
                lines["total_line".concat(index)] = line.total;
            });
            return __assign({ numero: ticket.numero, datebook: ticket.datebook, datecheck: ticket.datecheck, businessUnitName: ticket.businessUnitName, operationLineName: ticket.operationLineName, stretchName: ticket.stretchName, origin: ticket.origin, destination: ticket.destination, username: ticket.username, terminal: ticket.terminal, daterefund: ticket.daterefund, datevalited: ticket.datevalited, netAmount: ticket.netAmount, taxAmount: ticket.taxAmount, discount: ticket.discount, discountReason: (_a = ticket.discountReason) !== null && _a !== void 0 ? _a : null, total: ticket.total, taxName: ticket.taxName, tin: ticket.tin, typePayment: ticket.tipoPago }, lines);
        });
        console.log('printedStretchTicketMapeados: ', printedStretchTicketMapeados);
        var filename = "".concat(item.terminalSN, " - ").concat(item.username, " - ").concat(item.dateOpen, " - ").concat(item.dateClose);
        var externalCloseBtn = React.createElement("button", { className: "close", style: { color: Theme.color.primary, position: 'absolute', top: '50px', right: '15px' }, onClick: this.toggle }, "\u00D7");
        // para operationlines
        // console.log('stretchLines: ', stretchLines)
        var stretchLinesMap = stretchLines.reduce(function (prev, line) {
            if (prev.has(line.operationLine)) {
                var temp = prev.get(line.operationLine) + line.total;
                prev.set(line.operationLine, temp);
            }
            else {
                prev.set(line.operationLine, line.total);
            }
            return prev;
        }, new Map());
        var stretchLinesArray = Array.from(stretchLinesMap);
        // para los movimientos
        var mapMovements = movements.reduce(function (prev, movement) {
            var key = movement.type + '-' + movement.concepto;
            if (prev.has(key)) {
                var temp = prev.get(key) + movement.importe;
                prev.set(key, temp);
            }
            else {
                prev.set(key, movement.importe);
            }
            return prev;
        }, new Map());
        var inTotalMovements = movements.reduce(function (prev, movement) {
            if (movement.type === TypeMovement.In) {
                prev += movement.importe;
            }
            return prev;
        }, 0);
        var outTotalMovements = movements.reduce(function (prev, movement) {
            if (movement.type === TypeMovement.Out) {
                prev += movement.importe;
            }
            return prev;
        }, 0);
        return (React.createElement("div", { className: "animated fadeIn" },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Modal, { centered: true, fade: true, isOpen: true, modalTransition: { timeout: 700 }, backdropTransition: { timeout: 1000 }, toggle: this.toggle, 
                        /*external={externalCloseBtn}*/
                        style: { width: '320px' } },
                        React.createElement(JsonToExcel, { title: "".concat(T('download'), " tickets ").concat(T('as'), " Excel"), data: printedStretchTicketMapeados, fileName: filename, btnClassName: 'custom-classname' }),
                        noUploaded && noUploaded.length > 0 && React.createElement(Button, { onClick: function () {
                                _this.handleNoUpload(noUploaded);
                            } },
                            React.createElement(Text, null, 'comprobar no subidos')),
                        React.createElement(ModalHeader, null, "Cierre de caja"),
                        React.createElement(ModalBody, null,
                            React.createElement("p", { style: {
                                    marginBottom: '5px',
                                    width: '100%',
                                    height: '1px',
                                    background: 'black',
                                } }, ''),
                            React.createElement("div", { style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                } },
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'Apertura: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(item.dateOpen))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'Cierre: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(item.dateClose))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'Operario:'),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(item.username))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'Dispositivo: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(item.terminalBrand))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-end'
                                    } },
                                    React.createElement("p", { style: { marginLeft: '10px', fontWeight: 'bold' } }, " ".concat(item.terminalSN))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'TOTAL: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(item.total, " ").concat(item.money))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'DESCUENTO: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(toRound(item.totalDescuento), " ").concat(item.money))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'ABONADO: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(toRound(item.totalRefund), " ").concat(item.money))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'EFECTIVO: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(toRound(item.totalCash), " ").concat(item.money))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'TARJETA: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, "".concat(toRound(item.totalCard), " ").concat(item.money))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'CREDITO: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, "".concat(toRound(item.totalCredit), " ").concat(item.money))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'TRANSFERENCIA: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, "".concat(toRound(item.totalTransfer), " ").concat(item.money))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'OTROS: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, "".concat(toRound(item.totalOther), " ").concat(item.money))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'CHECKINS: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(item.checkins))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'ENTRADA A CAJA: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(toRound(item.totalMovementIn), " ").concat(item.money))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'SALIDA DE CAJA: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, " ".concat(toRound(item.totalMovementOut), " ").concat(item.money))),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { fontWeight: 'bold' } }, 'DISPONIBLE EFECTIVO: '),
                                    React.createElement("p", { style: { marginLeft: '10px' } }, " ".concat(toRound(item.totalCashDisponible), " ").concat(item.money))),
                                item.movements.length === 0 && React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { fontWeight: 'bold' } }, 'NO HAY MOVIMIENTOS')),
                                item.movements.length > 0 && React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { fontWeight: 'bold' } }, 'LISTA DE MOVIMIENTOS')),
                                item.movements.length > 0 && item.movements.map(function (line) {
                                    return React.createElement("div", { key: line.id, style: { display: 'flex', flexDirection: 'column' } },
                                        React.createElement("div", { style: {
                                                width: '275px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-start'
                                            } },
                                            React.createElement("p", { style: { marginBottom: 0, } }, "".concat(toDateTime(line.date), " ")),
                                            React.createElement("p", { style: { marginBottom: 0, marginLeft: '15px' } }, line.type)),
                                        React.createElement("div", { style: {
                                                width: '275px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-start'
                                            } },
                                            React.createElement("p", { style: { marginBottom: 0, } }, "".concat(line.concepto))),
                                        React.createElement("div", { style: {
                                                width: '275px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-end'
                                            } },
                                            React.createElement("p", { style: { textAlign: 'end', width: '100%' } }, "Importe: ".concat(toRound(line.importe), " ").concat(item.money))));
                                }),
                                item.stretchLines.length === 0 && React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { fontWeight: 'bold' } }, 'NO HAY VENTAS DE SERVICIOS')),
                                item.stretchLines.length > 0 && React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { fontWeight: 'bold' } }, 'LISTA DE VENTAS SERVICIOS')),
                                item.stretchLines.length > 0 && item.stretchLines.map(function (line) {
                                    return React.createElement("div", { key: line.id, style: { display: 'flex', flexDirection: 'column' } },
                                        React.createElement("div", { style: {
                                                width: '275px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-start'
                                            } },
                                            React.createElement("p", { style: { marginBottom: 0, } }, "".concat(line.quantity, "x")),
                                            React.createElement("p", { style: { marginBottom: 0, marginLeft: '5px' } }, line.passengerCategory)),
                                        React.createElement("div", { style: styleLine },
                                            React.createElement("p", { style: { marginBottom: 0, textAlign: 'center' } }, line.operationLine),
                                            React.createElement("p", { style: { marginBottom: 0, textAlign: 'center' } }, line.stretch)),
                                        line.totalDiscount > 0 && React.createElement("div", { style: {
                                                width: '275px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-end'
                                            } },
                                            React.createElement("p", { style: { marginBottom: 0, textAlign: 'end', width: '200px' } }, "Descuento: ".concat(line.totalDiscount, " ").concat(line.money))),
                                        React.createElement("div", { style: {
                                                width: '275px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-end'
                                            } },
                                            React.createElement("p", { style: { textAlign: 'end', width: '100%' } }, "Total: ".concat(line.total, " ").concat(line.money))));
                                }),
                                stretchLinesArray.length > 0 &&
                                    React.createElement("p", { style: {
                                            marginBottom: '5px',
                                            width: '50%',
                                            height: '1px',
                                            background: 'black',
                                        } }, ''),
                                stretchLinesArray.length > 0 && stretchLinesArray.map(function (line) {
                                    return React.createElement("div", { key: line[0], style: { display: 'flex', flexDirection: 'column' } },
                                        React.createElement("div", { style: styleLine },
                                            React.createElement("p", { style: { marginBottom: 0, textAlign: 'center' } }, line[0])),
                                        React.createElement("div", { style: {
                                                width: '275px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-end'
                                            } },
                                            React.createElement("p", { style: { textAlign: 'end', width: '100%' } }, "Total: ".concat(toRound(line[1]), " ").concat(item.money))));
                                }),
                                stretchLinesArray.length > 0 &&
                                    React.createElement("p", { style: {
                                            marginBottom: '5px',
                                            width: '50%',
                                            height: '1px',
                                            background: 'black',
                                        } }, ''),
                                item.articleLines.length === 0 && React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { fontWeight: 'bold' } }, 'NO HAY VENTAS DE ARTÍCULOS')),
                                item.articleLines.length > 0 && React.createElement("div", { style: styleLine },
                                    React.createElement("p", { style: { fontWeight: 'bold' } }, 'LISTA DE VENTAS DE ARTÍCULOS')),
                                item.articleLines.length > 0 && item.articleLines.map(function (line) {
                                    return React.createElement("div", { key: line.id, style: { display: 'flex', flexDirection: 'column' } },
                                        React.createElement("div", { style: {
                                                width: '275px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-start'
                                            } },
                                            React.createElement("p", { style: { marginBottom: 0, } }, "".concat(line.quantity, "x")),
                                            React.createElement("p", { style: { marginBottom: 0, marginLeft: '5px' } }, line.articleName)),
                                        line.totalDiscount > 0 && React.createElement("div", { style: {
                                                width: '275px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-end'
                                            } },
                                            React.createElement("p", { style: { marginBottom: 0, textAlign: 'end', width: '200px' } }, "Descuento: ".concat(line.totalDiscount, " ").concat(line.money))),
                                        React.createElement("div", { style: {
                                                width: '275px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-end'
                                            } },
                                            React.createElement("p", { style: { textAlign: 'end', width: '100%' } }, "Total: ".concat(toRound(line.total), " ").concat(line.money))));
                                }),
                                React.createElement("p", { style: {
                                        marginBottom: '5px',
                                        width: '100%',
                                        height: '1px',
                                        background: 'black',
                                    } }, ''))))))));
    };
    TicketCashDeskDetail = __decorate([
        inject('store'),
        observer
    ], TicketCashDeskDetail);
    return TicketCashDeskDetail;
}(Component));
var styleLine = {
    width: '275px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};
export default TicketCashDeskDetail;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketCashDeskDetail.tsx
// module id = 1144
// module chunks = 0